var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesforce = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.826 4.16933C7.27738 3.69911 7.90622 3.40712 8.60136 3.40712C9.5254 3.40712 10.3319 3.92251 10.7612 4.68762C11.1453 4.51603 11.5614 4.42758 11.9821 4.42809C13.6489 4.42809 15 5.79111 15 7.47277C15 9.15442 13.6489 10.5174 11.9821 10.5174C11.7783 10.5174 11.5796 10.4971 11.3874 10.4583C11.0094 11.1325 10.2885 11.5882 9.46155 11.5882C9.11536 11.5882 8.78785 11.5086 8.49648 11.366C8.11308 12.2678 7.21996 12.8999 6.17925 12.8999C5.0955 12.8999 4.17161 12.214 3.81715 11.2522C3.65922 11.2856 3.49825 11.3023 3.33683 11.3023C2.04624 11.3025 1.00001 10.2454 1.00001 8.94129C0.999038 8.52801 1.10641 8.1217 1.31142 7.76286C1.51643 7.40402 1.81192 7.10518 2.16842 6.89614C2.02052 6.55534 1.94442 6.18773 1.94487 5.81622C1.94487 4.31632 3.16228 3.10059 4.66403 3.10059C5.08238 3.1001 5.49518 3.19631 5.87021 3.3817C6.24524 3.56709 6.57235 3.83664 6.826 4.16933Z",
    fill: "#00A1E0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesforce);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Salesforce.c12a7febcc658945374b2e7074ce0903.svg";